/**
 * A service's length in minutes — the same rule as the API's `ServiceDuration`.
 *
 * `durationUnit` is stored as the English word ("Minutes", "Hours"), so it is
 * data, never a label: printing it straight into a list put "45 Minutes" in
 * front of Romanian customers. Convert to minutes and let the translation say
 * "min".
 */
export const serviceMinutes = (service) => {
  const duration = Number(service?.duration) || 0;
  if (duration <= 0) return 0;
  const unit = String(service?.durationUnit || "").toLowerCase();
  return unit === "hours" || unit === "hour" ? duration * 60 : duration;
};
